import { LoaderFunctionArgs, useLoaderData, useParams } from "react-router-dom";
import { QueryClient, useQuery } from "@tanstack/react-query";
import { Divider } from "@nextui-org/react";
import BookingDetailsItem from "@/components/bookings/details/BookingDetailsItem";
import { ApiService } from "@/api/services/ApiService";
import { IWorkOrder } from "@/lib/types";

// ---------------------- API

const query = (bookingId: string) => ({
  queryKey: ["work-order-info", bookingId] as const,
  queryFn: async () => ApiService.bookings.getWorkOrder(bookingId),
});

export const loader =
  (queryClient: QueryClient) =>
  async ({ params }: LoaderFunctionArgs) => {
    const bookingId = params.id;

    if (!bookingId) throw new Error("Booking ID not found");

    try {
      return queryClient.ensureQueryData(query(bookingId));
    } catch (error) {
      throw error; // Let React Router handle the error
    }
  };

// ---------------------- Component

const BookingInstructions = () => {
  // --------- Variables / Hooks

  const { id = "" } = useParams();

  const initialData = useLoaderData() as IWorkOrder;

  const { data } = useQuery({
    ...query(id),
    initialData,
  });

  // --------- JSX

  return (
    <div className="flex h-auto w-full flex-grow flex-col gap-3">
      {/*******************************************/}
      {/* Work Order Instructions */}
      {/*******************************************/}

      <BookingDetailsItem title="Work Order Instructions">
        {data.instructions ?? "No work order instructions."}
      </BookingDetailsItem>

      <Divider className="my-4" />

      {/*******************************************/}
      {/* Dispatch Instructions */}
      {/*******************************************/}

      <BookingDetailsItem title="Dispatch Instructions">
        {data.dispatchInstructions ?? "No dispatch instructions."}
      </BookingDetailsItem>
    </div>
  );
};

export default BookingInstructions;
